import React, { createContext, useContext, useState } from "react";

const StateContext = createContext();

const initialState = {};

export const ContextProvider = ({ children }) => {
  const [activeMenu, setActiveMenu] = useState(true);
  const [isClicked, setIsClicked] = useState(initialState);
  const [screenSize, setScreenSize] = useState(undefined);

  const handleClick = (clicked) => {
    setIsClicked({ ...initialState, [clicked]: true });
  };
  return (
    <StateContext.Provider
      value={{
        activeMenu,
        setActiveMenu,
        isClicked,
        setIsClicked,
        handleClick,
        screenSize,
        setScreenSize,
      }}
    >
      {children}
    </StateContext.Provider>
  );
};

export const useStateContext = () => useContext(StateContext);

/**
 * 
 * 
**Documentation: ContextProvider

The ContextProvider component is a custom Context provider that wraps the application and provides a state management system using React's Context API. It initializes the initial state and creates a context to share and manage state throughout the application.

**Context:
StateContext: The context created using createContext(), which will be used to manage and share state throughout the application.


**Initial State:
initialState: An object that represents the initial state of the application. In this example, it is an empty object, but you can customize it with your desired initial state.


**State:
activeMenu: A state variable that manages the state of the active menu in the application.
isClicked: A state variable that holds information about clicked items in the application. In this example, 
it is initialized with initialState.
screenSize: A state variable to store the screen size, which can be used for responsive designs.

**Functions:
handleClick: A function that updates the isClicked state when an item is clicked. It sets the clicked item to true and resets
 all other items to false.

**Component Structure:
1. The ContextProvider component is defined to create a custom Context provider.
2. The StateContext is created using createContext() to create the context.
3. The component defines state variables activeMenu, isClicked, and screenSize using the useState hook.
4. The handleClick function is defined to handle click events and update the isClicked state accordingly.
5. The ContextProvider component wraps its children with the StateContext.Provider and provides the state and 
functions to its children as values.

**Usage:
The ContextProvider component is used at the root level of the application to provide a global state management system. 
It wraps the entire application and allows components deeper in the component tree to access and modify the state using 
the useStateContext hook.
 */
